export default __webpack_public_path__ + "maps-examples-point-conversion-thumbnail-960-6b5aad5a26bba691278f4d07d3b54970.webp";